<template lang="html">
  <div class="license-component">
    <br>
    <v-container>
      <v-progress-linear
            v-if="preloader"
            indeterminate
            color="red"
      ></v-progress-linear>
      <v-form
        ref="diak_license_form"
        v-model="valid"
        lazy-validation
        v-show="!preloader"
      >
      <v-row>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
          v-model="license_number"
          label="Vezetői engedély száma"
          :rules="[rules.required]"
          outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-if="contract_type != 4 || contract_type == null"
            v-model="issuer_country"
            :items="country_list"
            item-text="country"
            item-value="code"
            label="Kibocsátó ország"
            :rules="[rules.required]"
            outlined
          ></v-select>
          <v-autocomplete
            v-if="contract_type == 4"
            v-model="gki_issuer_country"
            :items="gki_country_list"
            item-text="Megnevezes"
            item-value="Azonosito"
            label="Kibocsátó ország"
            :rules="[gkiLicenseRule]"
            outlined
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="medical_suitability_group"
            :items="medical_group"
            item-text="med_group"
            item-value="code"
            label="Egészségügyi csoport kódja"
            :rules="[rules.required]"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
          v-model="restriction_code"
          label="Korlátozás kódja"
          outlined
          ></v-text-field>
        </v-col>
      </v-row>
      <div class="subtitle-1">Kategóriák</div>
      <v-divider></v-divider><br>
      <v-card
        v-for="(license, index) in license_details" v-bind:key="index"
        outlined
        shaped
        class="mb-2"
      >
      <v-card-text>
      <v-row>
        <v-col cols="12" sm="6" md="2">
          <v-select
            v-model="license.course_type_id"
            :items="category_list"
            item-text="category"
            item-value="category"
            label="Kategória"
            :rules="[rules.required]"
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
          v-model="license.issue_date"
          label="Vizsgadátum"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          :rules="[rules.required]"
          outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4">
          <v-text-field
          v-model="license.validity_date"
          label="Érvényesség"
          v-mask="'####-##-##'"
          hint="formátum: éééé-hh-nn"
          :rules="[rules.required]"
          outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn @click="removeLicenseLine(index, license.line_id)" color="red" outlined class="mt-2">
            törlés
          </v-btn>
        </v-col>
      </v-row>
      </v-card-text>
      </v-card>
      </v-form>
      <v-row>
        <v-col cols="6" md="2">
        <v-btn
          color="primary"
          @click="addLicenseLine"
          rounded
          
        >
        Hozzáad
        </v-btn>
        </v-col>
        <v-col cols="6" md="2">
        <v-btn
          color="primary"
          @click="save_license_dialog = true"
          rounded
          
        >
        Rögzít
        </v-btn>
        </v-col>
        <v-col cols="12" md="3" v-if="license_head_id">
        <v-btn
          color="red"
          @click="del_license_dialog = true"
          outlined
          
        >
        vezetői engedély törlése
        </v-btn>
        </v-col>
      </v-row>
      <br>
      <div v-if="contract_type == 4">
        <div class="subtitle-1">GKI kártya adatai</div>
        <v-divider></v-divider><br>
        <v-form
          ref="gki_card_form"
          v-model="gki_valid"
          lazy-validation
        >
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
            v-model="gki_card_number"
            label="Száma"
            outlined
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
            v-model="gki_issue_date"
            label="Kiállítás dátuma"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            outlined
            :rules="[gkiCardRules]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <v-text-field
            v-model="gki_validity_date"
            label="Érvényesség vége"
            v-mask="'####-##-##'"
            hint="formátum: éééé-hh-nn"
            outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4">
          <v-btn
            color="primary"
            rounded
            class="mr-3"
            :disabled="!license_head_id || !gki_valid"
            @click="saveGKICard"
          >
          Rögzít
          </v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="4">
          <v-btn
            color="red"
            rounded
            outlined
            class="mr-3"
            :disabled="!gki_card_number"
            @click="delGKICard"
          >
          Töröl
          </v-btn>
          </v-col>
        </v-row>
        </v-form>
        <p v-if="!license_head_id">Vezetői engedély adatok nélkül nem rögzíthető!</p>
      </div>

    </v-container>
    <v-dialog v-model="save_license_dialog" persistent max-width="300">
      <v-card>
        <v-card-text class="pt-4">Biztosan menteni szeretné az adatokat?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="validate(), save_license_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="save_license_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="del_license_dialog" persistent max-width="450">
      <v-card>
        <v-card-text class="pt-4">Biztosan törölni szeretné a vezetői engedélyt és minden adatát?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="delLicense(), del_license_dialog = false">Igen</v-btn>
          <v-btn color="primary" text @click="del_license_dialog = false">Nem</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="pallasz_dialog" persistent max-width="600">
      <v-card>
        <v-container>
        <p><b>Szeretné a változást a KAV rendszerében is rögzíteni?</b></p>
        <v-simple-table>
            <thead>
              <tr>
                <th class="text-left">
                  Tanuló azonosító
                </th>
                <th class="text-left">
                  Tanfolyam kezdete
                </th>
                <th class="text-left">
                  Tanfolyam vége
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="item in pallasz_ids"
                :key="item.pallasz_id"
              >
                <td>{{ item.course_student_id }}</td>
                <td>{{ item.start_date }}</td>
                <td>{{ item.end_date }}</td>
                <td>
                  <v-btn color="green" outlined @click="GKIJogsiUpdate(item.pallasz_id, item.course_data_id)" :loading="preloader" :disabled="preloader">rögzít</v-btn>
                </td>
              </tr>
            </tbody>
        </v-simple-table>
        <v-card-actions>
          <v-btn color="red" outlined @click="pallasz_dialog = false">bezár</v-btn>
        </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="save_license_snackbar" bottom>
      {{save_license_response}}
      <v-btn color="pink" text @click="save_license_snackbar = false">
        Bezár
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import store from '../store'

import {
  mapFields
} from 'vuex-map-fields'

  export default {
    data () {
      return {
        license_details: [],
        license_number: '',
        license_head_id: '',
        country_list: [],
        issuer_country: '',
        medical_group: [],
        medical_suitability_group: '',
        restriction_code: '',
        category_list: '',
        rules: {
            required: value => !!value || 'Kötelező mező!',
        },
        valid: true,
        delete_lines: [],
        save_license_dialog: false,
        save_license_snackbar: false,
        save_license_response: '',
        gki_card_number: '',
        gki_issue_date: '',
        gki_validity_date: '',
        gki_valid: true,
        gki_country_list: [],
        gki_issuer_country: '',
        pallasz_dialog: false,
        pallasz_ids: [],
        del_license_dialog: false,
      }
    },
    methods: {
      getLicenseDetails: async function() {
        store.state.showing.preloader = true
        this.contracts = null
        this.license_number = null
        this.issuer_country = null
        this.medical_suitability_group = null
        this.restriction_code = null
        this.license_head_id = null
        this.gki_card_number = null
        this.gki_issue_date = null
        this.gki_validity_date = null
        await this.gettoken()
        this.$http.post('/diakok/license_details', {
          token: this.token,
          customer_id: this.customer_id
        }).then((response) => {
          store.state.showing.preloader = false
          this.license_details = response.data['license_lines']
          this.license_head_id = response.data['license_head'][0]['head_id']
          this.license_number = response.data['license_head'][0]['serial_number']
          this.issuer_country = response.data['license_head'][0]['issuer_country']
          this.gki_card_number = response.data['license_head'][0]['gki_card_number']
          this.gki_issue_date = response.data['license_head'][0]['gki_issue_date']
          this.gki_validity_date = response.data['license_head'][0]['gki_validity_date']
          if (response.data['license_head'][0]['issuer_country'] == null) {
            this.issuer_country = 'H'
          }
          this.medical_suitability_group = response.data['license_head'][0]['medical_suitability_group']
          this.restriction_code = response.data['license_head'][0]['restriction_code']
          this.gki_issuer_country = response.data['license_head'][0]['gki_issuer_country']
        }, (error) => {
          console.log(error.data);
        })
      },
      delLicense: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/del_license', {
          token: this.token,
          customer_id: this.customer_id
        }).then((response) => {
          this.getLicenseDetails();
          store.state.showing.preloader = false
          this.save_license_response = response.data
          this.save_license_snackbar = true
        }, (error) => {
          console.log(error.data);
        })
      },
      getCountryList() {
        store.state.showing.preloader = true
        this.$http.get('/wsdl/dlcountry'
        ).then((response) => {
          store.state.showing.preloader = false
          this.country_list = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getGKICountryList() {
        store.state.showing.preloader = true
        this.$http.get('/diakok/pallasz/gki_issuer_countries'
        ).then((response) => {
          store.state.showing.preloader = false
          this.gki_country_list = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getCategoryList() {
        store.state.showing.preloader = true
        this.$http.get('/wsdl/dlcategory'
        ).then((response) => {
          store.state.showing.preloader = false
          this.category_list = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      getMedGroup() {
        store.state.showing.preloader = true
        this.$http.get('/wsdl/dlmedgroup'
        ).then((response) => {
          store.state.showing.preloader = false
          this.medical_group = response.data

        }, (error) => {
          console.log(error.data);
        })
      },
      addLicenseLine() {
        if (this.license_details != '') {
          this.license_details.push({
            course_type_id: null,
            issue_date: null,
            validity_date: this.license_details[0]['validity_date']
          })
        } else {
          this.license_details.push({
            course_type_id: null,
            issue_date: null,
            validity_date: null
          })
        }
      },
      removeLicenseLine (lineId, dbid) {
        this.license_details.splice(lineId, 1)
        this.delete_lines.push({
          line_id: dbid,
        })
        console.log(this.delete_lines);
      },
      saveLicenseDetails: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/save_license_details_20210218', {
          token: this.token,
          customer_id: this.customer_id,
          head_id: this.license_head_id,
          license_details: this.license_details,
          license_number: this.license_number,
          issuer_country: this.issuer_country,
          gki_issuer_country: this.gki_issuer_country,
          medical_suitability_group: this.medical_suitability_group,
          restriction_code: this.restriction_code,
          delete_lines: this.delete_lines
        }).then((response) => {
          this.save_license_response = response.data
          this.save_license_snackbar = true
          store.state.showing.preloader = false
          //this.pallaszCheck()
          this.getLicenseDetails()
          this.delete_lines = []
        }, (error) => {
          console.log(error.data);
        })
      },
      saveGKICard: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/save_gki_card', {
          token: this.token,
          head_id: this.license_head_id,
          gki_card_number: this.gki_card_number,
          gki_issue_date: this.gki_issue_date,
          gki_validity_date: this.gki_validity_date
        }).then((response) => {
          this.save_license_response = response.data
          this.save_license_snackbar = true
          store.state.showing.preloader = false
          this.getLicenseDetails()
          //this.pallaszCheck()
        }, (error) => {
          console.log(error.data);
        })
      },
      delGKICard: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/delete_gki_card', {
          token: this.token,
          head_id: this.license_head_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.save_license_response = response.data
          this.save_license_snackbar = true
          store.state.showing.preloader = false
          this.getLicenseDetails()
        }, (error) => {
          console.log(error.data);
        })
      },
      pallaszCheck: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/pallasz/pallasz_check', {
          token: this.token,
          customer_id: this.customer_id
        }).then((response) => {
          console.log(response.data);
          store.state.showing.preloader = false
          if (response.data['success'] == true) {
            this.pallasz_dialog = true
            this.pallasz_ids = response.data['pallasz']
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      GKIJogsiUpdate: async function(pallasz_id, course_data_id) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/pallasz/gki_jellap_update_docs', {
          token: this.token,
          course_data_id: course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: pallasz_id
        }).then((response) => {
          this.preloader = false
          this.save_license_response = response.data['message']
          this.save_license_snackbar = true
          if (response.data['result'] == 'success') {
            this.pallasz_dialog = false
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      validate () {
        if (this.$refs.diak_license_form.validate()) {
          //this.save_student_dialog = true
          this.saveLicenseDetails()
          }
        },
      resetValidation () {
          this.$refs.diak_license_form.resetValidation()
        },
    },
    mounted() {
      this.getCountryList()
      this.getMedGroup()
      this.getCategoryList()
      this.getGKICountryList()
      this.resetValidation()
    },
    watch: {
      customer_id() {
        if (this.diakok_tab == 1) {
          this.getLicenseDetails()
          this.delete_lines = []
        }
      },
      license_details() {
          this.resetValidation()
      },
      diakok_tab: function (value) {
        if (value == 1) {
          this.getLicenseDetails()
          this.delete_lines = []
        }
      }
    },
    computed: {
    ...mapFields([
      'showing.preloader',
      'diakok_details.customer_id',
      'diakok_details.contract_id',
      'diakok_details.diakok_tab',
      'diakok_details.contract_type',
    ]),
    gkiCardRules: function () {
      if (this.gki_card_number && !this.gki_issue_date) {
        this.gki_valid = false
        return "Kötelező mező!"
      } else {
        return true
      }
    },
    gkiLicenseRule() {
      if (!this.gki_issuer_country) {
        this.valid = false
        return "Kötelező mező!"
      } else {
        return true
      }
    }
  },
  }
</script>

<style lang="css">
</style>
